// TimelineHeader.js - Month, week and day headers
import React from 'react';
import { Box, useTheme } from '@mui/material';
import MonthHeader from '../header/MonthHeader';
import WeekHeader from '../header/WeekHeader';
import DayHeader from '../header/DayHeader';

const TimelineHeader = ({ monthGroups, weekGroups, visibleDayIndices, getDateForDayIndex, formatDay, dayWidth, stickyLeft = 0 }) => {
  const theme = useTheme();

  return (
    <>
      {/* Month Headers */}
      <Box sx={{
        display: 'flex',
        height: '40px',
        bgcolor: 'grey.800',
        borderBottom: `1px solid ${theme.palette.grey[700]}`,
        position: 'sticky',
        top: 0,
        zIndex: 150,
      }}>
        {monthGroups.map((group, index) => (
          <MonthHeader
            key={`${group.month}-${group.actualStartDay}`}
            group={group}
            dayWidth={dayWidth}
            isLast={index >= monthGroups.length - 1}
            stickyLeft={stickyLeft}
          />
        ))}
      </Box>

      {/* Week Headers */}
      <Box sx={{
        display: 'flex',
        height: '28px',
        bgcolor: 'grey.700',
        borderBottom: `1px solid ${theme.palette.grey[600]}`,
        position: 'sticky',
        top: '40px',
        zIndex: 145,
      }}>
        {weekGroups.map((group, index) => (
          <WeekHeader
            key={`${group.week}-${group.actualStartDay}`}
            group={group}
            dayWidth={dayWidth}
            isLast={index >= weekGroups.length - 1}
          />
        ))}
      </Box>

      {/* Day Headers */}
      <Box sx={{
        display: 'flex',
        height: '40px',
        bgcolor: 'grey.600',
        borderBottom: `2px solid ${theme.palette.grey[700]}`,
        position: 'sticky',
        top: '68px',
        zIndex: 140,
      }}>
        {visibleDayIndices.map((dayIndex) => (
          <DayHeader
            key={dayIndex}
            dayIndex={dayIndex}
            day={getDateForDayIndex(dayIndex)}
            formatDay={formatDay}
            dayWidth={dayWidth}
          />
        ))}
      </Box>
    </>
  );
};

export default TimelineHeader;